import React, { useEffect, useRef, useState, useCallback, memo } from 'react';
import { ReactComponent as Vtablet300250 } from '../../src/img/vipad-300x250.svg';
import { ReactComponent as Vtablet300600 } from '../../src/img/vipad-300x600.svg';
import { ReactComponent as Pc970250 } from '../../src/img/pc-970x250.svg';
import { ReactComponent as Pc160600 } from '../../src/img/pc-160x600.svg';
import { ReactComponent as Ctv } from '../../src/img/ctv.svg';
import { ReactComponent as Expand } from '../../src/img/expand_content.svg';
import { GetCopy } from '../util/GetCopy';
import { useAppState } from '../context/State';
import { ReactComponent as Collapse } from '../../src/img/collapse_all.svg';

const Device = ({ brandData, adSize, selected }) => {
  const sizeToUse = brandData['16:9'] ? brandData['16:9'] : brandData[adSize];
  const videoRef = useRef(null);
  const videoSrcRef = useRef(null);
  const state = useAppState();
  const [isLoading, setIsLoading] = useState(true);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  const handleVideoLoad = useCallback(() => {
    setIsLoading(false);
    setIsVideoLoaded(true);
  }, []);

  const handleVideoError = useCallback(() => {
    setIsLoading(false);
    setIsVideoLoaded(true);
  }, []);

  const handleVideoLoadStart = useCallback(() => {
    setIsLoading(true);
    setIsVideoLoaded(false);
  }, []);
  useEffect(() => {
    const videoElement = videoRef.current;

    if (videoElement) {
      // Start playing the video
      videoElement.play();

      // Enable looping
      videoElement.loop = true;

      // Clean up on component unmount
      return () => {
        videoElement.pause();
      };
    }
  }, []);

  // Track video source changes and only reset when source actually changes
  useEffect(() => {
    const newSrc = sizeToUse?.[0]?.url;
    if (videoSrcRef.current !== newSrc) {
      videoSrcRef.current = newSrc;
      setIsLoading(true);
      setIsVideoLoaded(false);
      
      // Fallback: if video events don't fire, trigger fade-in after a delay
      const fallbackTimer = setTimeout(() => {
        setIsLoading(false);
        setIsVideoLoaded(true);
      }, 2000);
      
      return () => clearTimeout(fallbackTimer);
    }
  }, [brandData, adSize]);

  const getTablet = useCallback((adSize) => {
    switch (adSize) {
      case '300x250':
        return <Vtablet300250 />;
      case '300x600':
        return <Vtablet300600 />;
      case '970x250':
        return <Pc970250 />;
      case '160x600':
        return <Pc160600 />;
      case '16:9':
        return <Ctv />;
      default:
        return <Ctv />;
    }
  }, []);

  if (sizeToUse) {
    return (
      <div className={`deviceDisplay x${adSize ? adSize : 'CTV'} d-flex justify-content-center`}>
        {getTablet(adSize)}
        <div className={`deviceLoader deviceVideoFile ${'s' + (adSize === '16:9' ? '169' : adSize || '169')} ${isLoading ? 'loading' : ''}`}>
          <video 
            ref={videoRef} 
            autoPlay={true} 
            playsInline 
            controls={false} 
            muted 
            src={sizeToUse[0]['url']}
            onLoadStart={handleVideoLoadStart}
            onLoadedData={handleVideoLoad}
            onError={handleVideoError}
            className={isVideoLoaded ? 'video-fade-in' : ''}
          />
        </div>
        {selected !== 'Mobile' && (
          <div
            className="expandContract"
            onClick={() => {
              state.setExpanded(!state.expanded);
            }}
          >
            {!state.expanded && (
              <>
                <Expand width={15} height={15} /> <GetCopy copy="expand" />
              </>
            )}
            {state.expanded && (
              <>
                <Collapse width={15} height={15} /> <GetCopy copy="minimize" />
              </>
            )}
          </div>
        )}
      </div>
    );
  }
  return null;
};

export default memo(Device);
